<template>
  <div class="oldTreePage">
    <!-- 地图页 -->
    <div class="forestMap" v-if="param.showMap">
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div :class="['forestTab', this.param.showMap == false ? 'SmallTab' : '']">
      <van-tabs v-model="activeName">
        <van-tab
          :title="$t('linLongMsg.baseTit')"
          name="oldTreeMsg"
          class="baseMsg"
        >
          <old-tree-msg :dataInfo="param"></old-tree-msg>
        </van-tab>
        <!-- <van-tab
          :title="$t('oldTree.oldTreeAffiliationTit')"
          name="oldTreeAffiliation"
          v-if="forestShowtype"
          class="oldTreeAffiliation"
        >
          <old-tree-affiliation :dataInfo="param"></old-tree-affiliation>
        </van-tab> -->
        <van-tab title="古树监测" name="oldTreeMonitor" class="oldTreeMonitor">
          <old-tree-monitor :dataInfo="param"></old-tree-monitor>
        </van-tab>
        <van-tab
          :title="$t('common.ImgsTit')"
          name="oldTreeImgs"
          class="oldTreeImgs"
        >
          <old-tree-imgs :dataInfo="param"></old-tree-imgs>
        </van-tab>

        <van-tab
          :title="$t('common.commentTit')"
          name="oldTreeComment"
          class="oldTreeComment"
        >
          <old-tree-comment :dataInfo="param"></old-tree-comment>
        </van-tab>
      </van-tabs>
      <!-- <refresh-page v-if="refreshPage" /> -->
    </div>
    <!-- 网络失败 -->
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/components/map/MapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const oldTreeMsg = () => import("@/components/oldTreeModule/oldTreeMsg");
const oldTreeEvaluate = () =>
  import("@/components/oldTreeModule/oldTreeEvaluate");
const oldTreeComment = () =>
  import("@/components/oldTreeModule/oldTreeComment");
const oldTreeAffiliation = () =>
  import("@/components/oldTreeModule/affiliation");
const oldTreeMonitor = () => import("@/components/oldTreeModule/monitorPage");
const oldTreeImgs = () => import("@/components/oldTreeModule/oldTreeImgs");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "oldTree",
  data() {
    return {
      oldTreeId: "",
      mapData: {
        type: "geo_gushu",
        objid: "",
      },
      refreshPage: false,
      forestShowtype: false,
      activeName: "oldTreeMsg", //默认选中第一项
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    mapLocator,
    oldTreeMsg,
    oldTreeMonitor,
    oldTreeEvaluate,
    oldTreeComment,
    oldTreeAffiliation,
    oldTreeImgs,
    refreshPage,
  },
  mounted() {
    document.title = "古树名木信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.oldTreeId = this.$route.query.commonId;
      if (JSON.stringify(this.param) === "{}") {
        this.param.showMap = true;
      }
      if (this.oldTreeId == undefined) {
        this.oldTreeId = this.param.id;
      }
      this.getPoint();
      this.$set(this.mapData, "objid", this.oldTreeId);
    });
  },
  methods: {
    getPoint() {
      let _this = this;
      console.log(this.oldTreeId, "this.oldTreeId ");
      _this.$api.universal.oldTree
        .oldTreeMsg(_this.oldTreeId)
        .then((res) => {
          if (res.code == "1") {
            
            // _this.mapData.objid = res.data.id;
            // // _this.param.treeId = res.data.id;
            _this.$set(_this.mapData, "objid", res.data.id);
            // _this.showForestType(res.data.geometry);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    showForestType(info) {
      let _this = this;
      _this.$api.universal.oldTree
        .geoGuShuMsg({
          geometry: info,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null) {
              _this.forestShowtype = false;
            } else {
              _this.forestShowtype = true;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  watch: {
    param: {
      handler: function () {
        let _this = this;

        _this.oldTreeId = _this.param.id;
        // _this.getPoint();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.oldTreePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .forestMap {
    width: 100%;
    height: 40%;

    > div {
      height: 100%;
    }
  }

  .forestTab {
    width: 100%;
    height: 60%;
    position: relative;
    .van-tabs {
      height: 100%;
      height: 100%;

      overflow: hidden;

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }

      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__content {
        width: 100%;
        height: calc(100% - 45px);

        .van-tab__pane {
          width: 100%;
        }

        .oldTreeComment.van-tab__pane,
        .baseMsg.van-tab__pane,
        .oldTreeEvaluate.van-tab__pane,
        .oldTreeAffiliation.van-tab__pane,
        .oldTreeImgs.van-tab__pane,
        .oldTreeMonitor.van-tab__pane {
          height: 100%;
          overflow-y: scroll;
          background-color: #fff;
        }
        // .oldTreeMonitor.van-tab__pane {
        //   height: 100%;
        //   background-color: #fff;
        // }
        .oldTreeAffiliation.van-tab__pane {
          background-color: #f6f6f6;
        }
      }
    }
  }

  .forestTab.SmallTab {
    height: 100%;
  }
}
</style>